@if (stockLevel === null || stockLevel === undefined) {
  <app-ui-loading minHeight="20"></app-ui-loading>
} @else {
  @switch (stockLevel) {
    @case (stockLevelConstants.UNAVAILABLE_STOCK_LEVEL_VALUE) {
      -
    }
    @case (stockLevelConstants.MAXIMUM_STOCK_LEVEL_TRESHOLD_REPRESENTATION) {
      {{ stockLevelConstants.MAXIMUM_STOCK_LEVEL_ALLOWED_NUMBER_TO_SHOW }}
    }
    @default {
      {{ stockLevel }}
    }
  }
}
